import DayPointer from './DayPointer';

export default DayPointer;
